export enum LogLevel {
  DEBUG,
  INFO,
  WARN,
  ERROR,
  OFF,
}
